import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { breakpoint } from '../theme/breakpoint';

export const Item = styled.a`
  display: block;
  position: relative;
  margin-bottom: 1.35%;
  width: 100%;
`;

export const Feed = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.medium};

  ${breakpoint.tablet`
    flex-direction: ${({ $vertical }) => ($vertical ? 'column' : 'row')};
    flex-wrap: wrap;

    ${Item} {
      width: ${({ $vertical }) => ($vertical ? '100%' : '32.433%')};
      margin-bottom: ${({ $vertical, theme }) =>
        $vertical ? theme.spacing.small : '1.35%'};
      margin-right: ${({ $vertical }) => ($vertical ? 0 : '1.35%')};

      &:nth-child(3) {
        margin-right: 0;
      }
    }
  `}
`;
export const Image = styled.img`
  height: 100%;
  left: 0;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const ImageContainer = styled.div`
  padding-top: 100%;
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.palette.lightBackground};
`;

export const Icon = styled(SVG)`
  fill: ${({ theme }) => theme.palette.white};
  height: ${({ theme }) => theme.spacing.xlarge};
  left: ${({ theme }) => theme.spacing.medium};
  position: absolute;
  top: ${({ theme }) => theme.spacing.medium};
  width: ${({ theme }) => theme.spacing.xlarge};
`;
